import script from "./SamplingPointMuestras.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./SamplingPointMuestras.view.vue?vue&type=script&lang=ts&setup=true"

import "./SamplingPointMuestras.view.vue?vue&type=style&index=0&id=0a6ff54c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6ff54c"]])

export default __exports__